// extracted by mini-css-extract-plugin
export default {"textWrapper":"StatsMobileCard_textWrapper__3NK2d","summaryText":"StatsMobileCard_summaryText__YBJMe","underlineText":"StatsMobileCard_underlineText__JiH2F"};